class Elementor_Opal_Product_Categories {
    static instance;

    static getInstance() {
        if (!Elementor_Opal_Product_Categories.instance) {
            Elementor_Opal_Product_Categories.instance = new Elementor_Opal_Product_Categories();
        }
        return Elementor_Opal_Product_Categories.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-product-categories.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if ($carousel.length > 0) {
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));

                let $carousel_prev = $scope.find('.owl-prev');
                let $carousel_next = $scope.find('.owl-next');
                if (elementorFrontendConfig.is_rtl) {
                    alert('aaa');

                    if ($carousel_next.offset().left < 10) {
                        $carousel_next.css({
                            left: 15,
                        });

                        $carousel_prev.css({
                            right: 15,
                        });
                    }
                } else {
                    if ($carousel_prev.offset().left < 10) {
                        $carousel_prev.css({
                            left: 15,
                        });

                        $carousel_next.css({
                            right: 15,
                        });
                    }
                }
            }

        });
    }
}


Elementor_Opal_Product_Categories.getInstance();